import './Style.scss';
import * as React from 'react';

interface Props {
  checked: boolean;
  label: string;
  onChange: (checked: boolean) => void;
}

export default function RepeatOn(props: Props) {

  return (
    <label
      className="ro-container"
    >
      <input
        type="radio"
        checked={props.checked}
        onChange={(e) => props.onChange(e.target.checked)}
      />
      <span className="sc-checkmark">{props.label}</span>
    </label>
  );
}
